module.exports = __webpack_public_path__ + "static/media/19ESCAP11.e653309c.jpg";